var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":"","max-width":"200px"}},[_c('label',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-btn',{attrs:{"dark":"","fab":"","small":"","color":"gradiente"}},[_vm._v(" ? ")])],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }